t = require('views/internal/teacup-with-helpers')('ad_business_class_google_apps')
getExperiment = require 'lib/experiments/simple-test'

module.exports = t.renderable ({ upgradeUrl }) ->
  adsLayoutExperimentEnabled = getExperiment('adsLayout').get('enabled')

  if adsLayoutExperimentEnabled
    t.span '.title', ->
      t.format 'ads-title'
    t.div '.links', ->
      t.span '.upgrade', ->
        t.a { href: upgradeUrl }, ->
          t.format 'upgrade'
      t.span '.learn-more', ->
        t.a { href: '/business-class' }, ->
          t.format 'ads-learn-more'
  else
    t.span '.title', ->
      t.format 'using-google-apps'
    t.span '.learn-more', ->
      t.a { href: '#' }, ->
        t.format 'learn-about-business-class-ellipsis'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/ad_business_class_google_apps.coffee